<template>
  <CustomModal id="evaluation-service-gone-modal"
               class="basic-modal hide-cancel-btn"
               v-bind:title="'공지사항'"
               v-bind:ok-title="$t('common.confirm')"
               v-on:ok="$emit('ok')">

    <div class="evaluation-service-gone-container">
안녕하세요 클래스팅 러닝을 사랑해 주시는 선생님들께 진심으로 감사의 말씀을 드립니다.<br />
아쉽게도 8월 1일  자로 클래스팅 러닝 기능 중 '종합의견' 서비스가 종료됩니다.<br />
선생님들께서는 종료  일정을 참고하시어 이용에 불편이 없으시길 바랍니다.<br /><br />

다시 한번 '종합의견'을 아껴주셨던 모든 선생님들께 진심으로 감사의 말씀을 드리며,<br />
향후 더 좋은 서비스로 선생님들을 찾아뵐 수 있도록 노력하겠습니다.<br /><br />

감사합니다.<br />
클래스팅드림
    </div>
  </CustomModal>
</template>

<script>
  export default {
    name: 'evaluation-service-gone-modal',
  };
</script>

<style lang="scss">
  #evaluation-service-gone-modal {
    .modal-dialog {
      width: 580px;
    }

    .evaluation-service-gone-container {
      line-height: 24px;
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/evaluations/components/EvaluationServiceGoneModal.vue